const { MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { Button } = wp.components;
const { Fragment } = wp.element;
const { __ } = wp.i18n;

const BlockEdit = (props) => {

		const {attributes, setAttributes} = props;
		const mediaIds = props.attributes.images.map( item => item.mediaId );

		const onSelectMedia = (media) => {
			props.setAttributes( {
				images: media.map( item => {
					return {
						mediaId: parseInt( item.id, 10 ),
						mediaUrl: item.url,
						mediaAlt: item.alt_text,
						mediaCaption: item.caption,
					};
				} ),
			} );
		};

		const removeMedia = () => {
		props.setAttributes({
			images: []
		});
	}

		return (
			<div className="som-block-gallery">
				<div className="som-block-p2">
					{mediaIds.length >= 1 ?
						<div className="som-block-flex-wrap">
							{ attributes.images.map( item => (
								<img className="carousel-item som-block-thumbnail" src={item.mediaUrl} alt={item.mediaAlt} />
							) ) }
						</div>
						: <p> {__('Nincsennek kiálasztott képek.', 'semmelweis_museum')} </p>
					}
				</div>
				<div className="som-block-flex som-block-p2">
					<MediaUploadCheck>
						<MediaUpload 
							title={__('Képcsere', 'semmelweis_museum')}
							onSelect={onSelectMedia}
							value={mediaIds}
							allowedTypes={ ['image'] }
							gallery
							multiple
							render={({open}) => (
								<Button className="som-block-primary-button" onClick={open} >
								    { mediaIds.length >= 1 ? __('Slider szerkesztése', 'semmelweis_museum') :  __('Slider létrehozása', 'semmelweis_museum')  }	
								</Button>
							)}
						/>
					</MediaUploadCheck>
					
					{mediaIds.length >= 1 && 
						<MediaUploadCheck>
							<Button onClick={removeMedia} className="som-block-seconday-button">
								{ __('Képek eltávolítása ', 'semmelweis_museum') }
							</Button>
						</MediaUploadCheck>
					}
				</div>
			</div>
		);
}
		export default BlockEdit;